export default __webpack_public_path__ + "static/media/Well-worn Parasol.4653ca34.png";